import Message from '@/core/message'

const eventMap = {
  OPEN_CLOSE_SIDE_MENU: 'open close side menu'
}

const SideNavMessage = new Message(eventMap)
export default SideNavMessage
